import React from 'react';
import cx from 'classnames';
import styles from './EngageSidebar.module.scss';
import { Icon } from '../Icon';
import { useTranslation } from 'react-i18next';
import { CustomButton } from '../Button/Button';
import Popover from 'react-tiny-popover';

const SidebarChatWithUs = props => {
  const { mini, allowAnimation } = props;
  const { t } = useTranslation();
  const [isHover, setIsHover] = React.useState(false);

  const toggleChat = () => {
    if ($crisp && $crisp?.is) {
      if (!$crisp.is('chat:opened')) {
        $crisp.push(['do', 'chat:show']);
        $crisp.push(['do', 'chat:open']);
      } else {
        $crisp.push(['do', 'chat:hide']);
        $crisp.push(['do', 'chat:close']);
      }
    }
  };

  return (
    <Popover
      isOpen={mini && isHover}
      position={['right']}
      content={<div className={styles.popoverContainer}>{t('sidebar.chat_with_us')}</div>}
      containerStyle={{ zIndex: '999' }}
    >
      <div onMouseOver={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
        <CustomButton
          className={cx(styles.sidebarSection, { [styles.mini]: mini }, { [styles.animate]: allowAnimation })}
          variant="link"
          onClick={toggleChat}
          ariaLabel={mini && 'Chat with us'}
        >
          <Icon className={styles.sidebarIcon} src="chat_with_us" />
          {mini ? null : <span className={styles.name}>{t('sidebar.chat_with_us')}</span>}
        </CustomButton>
      </div>
    </Popover>
  );
};

export default SidebarChatWithUs;
